import { render, staticRenderFns } from "./BreakdownItem.vue?vue&type=template&id=65b5c40c&scoped=true&"
import script from "./BreakdownItem.vue?vue&type=script&lang=js&"
export * from "./BreakdownItem.vue?vue&type=script&lang=js&"
import style0 from "./BreakdownItem.vue?vue&type=style&index=0&id=65b5c40c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5c40c",
  null
  
)

component.options.__file = "BreakdownItem.vue"
export default component.exports